<google-map
  *ngIf="locations.length"
  [center]="{ lat: centerLat, lng: centerLng }"
  [zoom]="zoom"
  [height]="'60vh'"
  [width]="'100%'"
  (centerChanged)="onCenterChanged()"
  (zoomChanged)="onZoomChanged()"
>
  <map-marker
    *ngFor="let loc of locations"
    [position]="{ lat: lat(loc)!, lng: lng(loc)! }"
  ></map-marker>
</google-map>

<div *ngIf="!locations.length" class="text-sm text-gray-500">
  No locations to display.
</div>
